/**
 * assets/hide-no-search.js
 *
 * Hides products tagged "no-search" from storefront search by appending
 * `-tag:no-search` to the search query. Shopify filters the products on the
 * server, so result counts, filters and pagination stay correct.
 *
 * Covers: header/drawer search forms, predictive (live) search requests,
 * "View all" style links pointing to /search?q=...
 *
 * Deliberately NOT applied to:
 *  - wishlist / compare / recently-viewed lookups (they reuse /search with q=id:123 OR id:456 or ?view=...)
 *  - /search requests that already carry the exclusion
 *
 * A Liquid fallback (main-search / predictive-search sections) covers direct URL hits.
 */
(function () {
  'use strict';

  var TAG = 'no-search';
  var EXCLUDE = '-tag:' + TAG;

  // /search, /search/suggest, /search/suggest.json, optional locale prefix (/en, /en-in)
  var SEARCH_PATH = /^\/([a-z]{2}(-[a-z]{2})?\/)?search(\/suggest(\.json)?)?\/?$/i;

  function isInternalLookup(q, params) {
    var view = params && params.get ? params.get('view') : '';
    if (view === 'wishlist' || view === 'compare') return true;
    return /(^|[\s(])id:\d/i.test(q || '');
  }

  function addExclusion(q) {
    q = (q || '').trim();
    if (!q || q.indexOf(EXCLUDE) !== -1) return q;
    return q + ' ' + EXCLUDE;
  }

  function stripExclusion(q) {
    return (q || '').split(EXCLUDE).join('').replace(/\s+/g, ' ').trim();
  }

  function patchUrl(input) {
    try {
      var url = new URL(input, window.location.origin);
      if (url.origin !== window.location.origin) return input;
      if (!SEARCH_PATH.test(url.pathname)) return input;
      var q = url.searchParams.get('q');
      if (q === null || !q.trim()) return input;
      if (isInternalLookup(q, url.searchParams)) return input;
      url.searchParams.set('q', addExclusion(q));
      return url.toString();
    } catch (e) {
      return input;
    }
  }

  // 1) Predictive search / any ajax request to the search endpoints
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string') {
          input = patchUrl(input);
        } else if (typeof Request !== 'undefined' && input instanceof Request) {
          var patched = patchUrl(input.url);
          if (patched !== input.url) input = new Request(patched, input);
        }
      } catch (e) {}
      return nativeFetch.call(this, input, init);
    };
  }

  // 2) Search form submissions (header search, drawer search, search page form)
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      try {
        var path = new URL(form.getAttribute('action') || '', window.location.href).pathname;
        if (!SEARCH_PATH.test(path)) return;
      } catch (e) {
        return;
      }

      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) return;
      if (isInternalLookup(input.value, null)) return;

      var original = input.value;
      input.value = addExclusion(original);
      // Restore what the shopper typed once the browser has read the form data
      setTimeout(function () {
        input.value = original;
      }, 0);
    },
    true
  );

  // 3) Links to /search?q=... (e.g. "View all results", quick-search keywords)
  document.addEventListener(
    'click',
    function (event) {
      var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var patched = patchUrl(href);
      if (patched !== href && patched !== new URL(href, window.location.origin).toString()) {
        a.setAttribute('href', patched);
      }
    },
    true
  );

  // 4) Keep the exclusion token out of visible search boxes
  function cleanInputs() {
    var inputs = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].type !== 'hidden' && inputs[i].value.indexOf(EXCLUDE) !== -1) {
        inputs[i].value = stripExclusion(inputs[i].value);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanInputs);
  } else {
    cleanInputs();
  }
})();
